import { PRODUCT_COLORS } from '@/constants';
import type { ImageType } from '@/types';
import type { Product } from '@/types';

// 商品データから表示用のデータを作成する関数
export const getDisplayDataFromProduct = (product: Product, index: number, imageType: ImageType) => {
  // 配列のindexから色を決定（循環）
  const colorIndex = index % PRODUCT_COLORS.length;
  const color = PRODUCT_COLORS[colorIndex];
  return {
    id: product.id,
    imageSrc: product.imageUrls[imageType],
    iconSrc: product.imageUrls.icon,
    alt: product.name,
    productName: product.name,
    color: color,
  };
};
